import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from "./studio.reducer";

export const selectFeature = createFeatureSelector<State>('Studio');

export const StudioSelector = {
	selectRequestProcessing: createSelector(
		selectFeature,
		(state) => state.requestProcessing
	),

	selectGetStudiosResponse: createSelector(
		selectFeature,
		(state) => state.GetStudios.response
	),
	selectGetStudiosCriteia: createSelector(
		selectFeature,
		(state) => state.GetStudios.criteria
	),

	selectLikeStudio: createSelector(
		selectFeature,
		(state) => state.LikeStudio
	),

	selectPostComment: createSelector(
		selectFeature,
		(state) => state.PostComment
	),
};
